import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    ref: "dataform",
    attrs: {
      layout: "inline",
      model: _vm.form,
      labelAlign: "left"
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("保单状态"),
      prop: "policyStatus"
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("保单状态"),
      allowClear: ""
    },
    on: {
      change: _vm.agencyFun
    },
    model: {
      value: _vm.form.policyStatus,
      callback: function ($$v) {
        _vm.$set(_vm.form, "policyStatus", $$v);
      },
      expression: "form.policyStatus"
    }
  }, _vm._l(_vm.insuranceState, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.value
      }
    }, [_c("a-tooltip", {
      attrs: {
        placement: "top",
        title: _vm.$t(item.label)
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.label)) + " ")])], 1);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("姓名"),
      prop: "name"
    }
  }, [_c("a-input", {
    staticStyle: {
      "margin-left": "10px",
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("姓名"),
      allowClear: ""
    },
    model: {
      value: _vm.form.name,
      callback: function ($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("证件号码"),
      prop: "idNumber"
    }
  }, [_c("a-input", {
    staticStyle: {
      "margin-left": "10px",
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("证件号码"),
      allowClear: ""
    },
    model: {
      value: _vm.form.idNumber,
      callback: function ($$v) {
        _vm.$set(_vm.form, "idNumber", $$v);
      },
      expression: "form.idNumber"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("责任起期"),
      prop: "correctEffectiveTime"
    }
  }, [_c("a-range-picker", {
    attrs: {
      valueFormat: "YYYY-MM-DD"
    },
    model: {
      value: _vm.form.correctEffectiveTime,
      callback: function ($$v) {
        _vm.$set(_vm.form, "correctEffectiveTime", $$v);
      },
      expression: "form.correctEffectiveTime"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("备注"),
      prop: "remark"
    }
  }, [_c("a-input", {
    staticStyle: {
      "margin-left": "10px",
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("备注"),
      allowClear: ""
    },
    model: {
      value: _vm.form.remark,
      callback: function ($$v) {
        _vm.$set(_vm.form, "remark", $$v);
      },
      expression: "form.remark"
    }
  })], 1)], 1)], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: "24"
    }
  }, [_c("a-form-model-item", [_c("div", {
    staticStyle: {
      "margin-top": "2px"
    }
  }, [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))]), _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "edit"
    },
    on: {
      click: _vm.resetFun
    }
  }, [_vm._v(_vm._s(_vm.$t("重置")))]), _vm.isAuth("customer.personnelDetailsEndorsementList") ? _c("a-button", {
    staticClass: "marginR15",
    on: {
      click: _vm.toBatchList
    }
  }, [_vm._v(_vm._s(_vm.$t("批单")))]) : _vm._e()], 1)])], 1)], 1)], 1), _c("div", {
    staticStyle: {
      "text-align": "right",
      height: "32px"
    }
  }, [_vm.isAuth("customer.personnelDetailsExport") ? _c("a-button", {
    staticClass: "marginB15",
    staticStyle: {
      float: "right"
    },
    attrs: {
      type: "primary",
      ghost: "",
      loading: _vm.loading
    },
    on: {
      click: _vm.personnelExport
    }
  }, [_vm._v(_vm._s(_vm.$t("人员导出")))]) : _vm._e()], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      pagination: _vm.pagination,
      rowKey: "id",
      scroll: {
        x: true
      }
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function (text, record) {
        return [_vm.isAuth("customer.personnelDetailsDetail") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            size: "small",
            type: "primary"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "customerDetailInfo",
                params: {
                  id: _vm.$route.params.id,
                  detailId: record.personnelDetailsId
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("详情")))]) : _vm._e(), ["待生效", "保障中"].indexOf(record.policyStatus) != -1 && _vm.isAuth("customer.personnelDetailsEdit") && _vm.tag === 0 ? _c("a-button", {
          attrs: {
            size: "small",
            type: "edit",
            danger: ""
          },
          on: {
            click: function ($event) {
              return _vm.editPersonnel(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e()];
      }
    }, {
      key: "policyStatus",
      fn: function (text) {
        return [_c("span", {
          class: text === "退保中" || text === "已退保" ? "red-text" : ""
        }, [_vm._v(_vm._s(_vm.$t(text)))])];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _c("personnel-entry-model", {
    attrs: {
      dialogVisible: _vm.dialogVisible
    },
    on: {
      "update:dialogVisible": function ($event) {
        _vm.dialogVisible = $event;
      },
      "update:dialog-visible": function ($event) {
        _vm.dialogVisible = $event;
      },
      refreshList: _vm.refreshList
    }
  }), _c("batch-data-import", {
    attrs: {
      importVisible: _vm.importVisible
    },
    on: {
      "update:importVisible": function ($event) {
        _vm.importVisible = $event;
      },
      "update:import-visible": function ($event) {
        _vm.importVisible = $event;
      },
      refreshList: _vm.refreshList,
      cancel: _vm.cancelImport
    }
  }), _c("reduced-employee-modal", {
    attrs: {
      visible: _vm.reduceVisible,
      params: _vm.params
    },
    on: {
      ok: _vm.handleReduceOk,
      cancel: function ($event) {
        _vm.reduceVisible = false;
      }
    }
  }), _c("batch-list-model", {
    attrs: {
      batchListVisible: _vm.batchListVisible
    },
    on: {
      "update:batchListVisible": function ($event) {
        _vm.batchListVisible = $event;
      },
      "update:batch-list-visible": function ($event) {
        _vm.batchListVisible = $event;
      }
    }
  }), _c("batch-reduce-import", {
    attrs: {
      importReduceVisible: _vm.importReduceVisible
    },
    on: {
      "update:importReduceVisible": function ($event) {
        _vm.importReduceVisible = $event;
      },
      "update:import-reduce-visible": function ($event) {
        _vm.importReduceVisible = $event;
      },
      refreshList: _vm.refreshList,
      cancel: _vm.cancelReduceImport
    }
  }), _c("personnel-edit-model", {
    attrs: {
      personEditVisible: _vm.personEditVisible,
      editInfo: _vm.editInfo
    },
    on: {
      "update:personEditVisible": function ($event) {
        _vm.personEditVisible = $event;
      },
      "update:person-edit-visible": function ($event) {
        _vm.personEditVisible = $event;
      },
      refreshList: _vm.getList
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };